module.exports = __webpack_public_path__ + "static/TWAUS-brand-banner-mobile-90210f9dd7ae5b642c8810bd75b93078.png";